module.exports = __webpack_public_path__ + "img/wz-7-3-2.1429fc65.jpg";